/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteRouteImport } from './routes/_app.route'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as ApptenantsTenantsIndexRouteImport } from './routes/_app/(tenants)/tenants.index'
import { Route as AppteachersTeachersIndexRouteImport } from './routes/_app/(teachers)/teachers.index'
import { Route as AppsubjectsSubjectsIndexRouteImport } from './routes/_app/(subjects)/subjects.index'
import { Route as AppstudentsStudentsIndexRouteImport } from './routes/_app/(students)/students.index'
import { Route as AppsettingsSettingsIndexRouteImport } from './routes/_app/(settings)/settings.index'
import { Route as ApproomsRoomsIndexRouteImport } from './routes/_app/(rooms)/rooms.index'
import { Route as ApprequestsRequestsIndexRouteImport } from './routes/_app/(requests)/requests.index'
import { Route as AppprofileProfileIndexRouteImport } from './routes/_app/(profile)/profile.index'
import { Route as AppnotificationsNotificationsIndexRouteImport } from './routes/_app/(notifications)/notifications.index'
import { Route as AppnotesNotesIndexRouteImport } from './routes/_app/(notes)/notes.index'
import { Route as AppmydataMydataIndexRouteImport } from './routes/_app/(mydata)/mydata.index'
import { Route as AppmobileAppMobileAppIndexRouteImport } from './routes/_app/(mobile-app)/mobile-app.index'
import { Route as ApplessonsLessonsIndexRouteImport } from './routes/_app/(lessons)/lessons.index'
import { Route as AppfileManagementFileManagementIndexRouteImport } from './routes/_app/(file-management)/file-management.index'
import { Route as AppcustomEntitiesCustomEntitiesIndexRouteImport } from './routes/_app/(custom-entities)/custom-entities.index'
import { Route as AppcontractsContractsIndexRouteImport } from './routes/_app/(contracts)/contracts.index'
import { Route as AppclassesClassesIndexRouteImport } from './routes/_app/(classes)/classes.index'
import { Route as AppanalyticsAnalyticsIndexRouteImport } from './routes/_app/(analytics)/analytics.index'
import { Route as AppactivityActivityIndexRouteImport } from './routes/_app/(activity)/activity.index'
import { Route as AppaccountAccountIndexRouteImport } from './routes/_app/(account)/account.index'
import { Route as AppaadeMydataAadeMydataIndexRouteImport } from './routes/_app/(aade-mydata)/aade-mydata.index'
import { Route as AppstudentsStudentsSettingsRouteImport } from './routes/_app/(students)/students.settings'
import { Route as ApprequestsRequestsSettingsRouteImport } from './routes/_app/(requests)/requests.settings'
import { Route as ApplessonsLessonsSettingsRouteImport } from './routes/_app/(lessons)/lessons.settings'
import { Route as AppcontractsContractsSettingsRouteImport } from './routes/_app/(contracts)/contracts.settings'
import { Route as AppclassesClassesSettingsRouteImport } from './routes/_app/(classes)/classes.settings'
import { Route as AppaccountAccountSettingsRouteImport } from './routes/_app/(account)/account.settings'
import { Route as AppaccountAccountGradesRouteImport } from './routes/_app/(account)/account.grades'
import { Route as AppaadeMydataAadeMydataSettingsRouteImport } from './routes/_app/(aade-mydata)/aade-mydata.settings'
import { Route as AppcustomEntitiesCustomEntitiesBuilderIndexRouteImport } from './routes/_app/(custom-entities)/custom-entities.builder.index'
import { Route as AppcustomEntitiesCustomEntitiesSlugIndexRouteImport } from './routes/_app/(custom-entities)/custom-entities.$slug.index'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const ApptenantsTenantsIndexRoute = ApptenantsTenantsIndexRouteImport.update({
  id: '/(tenants)/tenants/',
  path: '/tenants/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppteachersTeachersIndexRoute =
  AppteachersTeachersIndexRouteImport.update({
    id: '/(teachers)/teachers/',
    path: '/teachers/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppsubjectsSubjectsIndexRoute =
  AppsubjectsSubjectsIndexRouteImport.update({
    id: '/(subjects)/subjects/',
    path: '/subjects/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppstudentsStudentsIndexRoute =
  AppstudentsStudentsIndexRouteImport.update({
    id: '/(students)/students/',
    path: '/students/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppsettingsSettingsIndexRoute =
  AppsettingsSettingsIndexRouteImport.update({
    id: '/(settings)/settings/',
    path: '/settings/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const ApproomsRoomsIndexRoute = ApproomsRoomsIndexRouteImport.update({
  id: '/(rooms)/rooms/',
  path: '/rooms/',
  getParentRoute: () => AppRouteRoute,
} as any)
const ApprequestsRequestsIndexRoute =
  ApprequestsRequestsIndexRouteImport.update({
    id: '/(requests)/requests/',
    path: '/requests/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppprofileProfileIndexRoute = AppprofileProfileIndexRouteImport.update({
  id: '/(profile)/profile/',
  path: '/profile/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppnotificationsNotificationsIndexRoute =
  AppnotificationsNotificationsIndexRouteImport.update({
    id: '/(notifications)/notifications/',
    path: '/notifications/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppnotesNotesIndexRoute = AppnotesNotesIndexRouteImport.update({
  id: '/(notes)/notes/',
  path: '/notes/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppmydataMydataIndexRoute = AppmydataMydataIndexRouteImport.update({
  id: '/(mydata)/mydata/',
  path: '/mydata/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppmobileAppMobileAppIndexRoute =
  AppmobileAppMobileAppIndexRouteImport.update({
    id: '/(mobile-app)/mobile-app/',
    path: '/mobile-app/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const ApplessonsLessonsIndexRoute = ApplessonsLessonsIndexRouteImport.update({
  id: '/(lessons)/lessons/',
  path: '/lessons/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppfileManagementFileManagementIndexRoute =
  AppfileManagementFileManagementIndexRouteImport.update({
    id: '/(file-management)/file-management/',
    path: '/file-management/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppcustomEntitiesCustomEntitiesIndexRoute =
  AppcustomEntitiesCustomEntitiesIndexRouteImport.update({
    id: '/(custom-entities)/custom-entities/',
    path: '/custom-entities/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppcontractsContractsIndexRoute =
  AppcontractsContractsIndexRouteImport.update({
    id: '/(contracts)/contracts/',
    path: '/contracts/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppclassesClassesIndexRoute = AppclassesClassesIndexRouteImport.update({
  id: '/(classes)/classes/',
  path: '/classes/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppanalyticsAnalyticsIndexRoute =
  AppanalyticsAnalyticsIndexRouteImport.update({
    id: '/(analytics)/analytics/',
    path: '/analytics/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppactivityActivityIndexRoute =
  AppactivityActivityIndexRouteImport.update({
    id: '/(activity)/activity/',
    path: '/activity/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppaccountAccountIndexRoute = AppaccountAccountIndexRouteImport.update({
  id: '/(account)/account/',
  path: '/account/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppaadeMydataAadeMydataIndexRoute =
  AppaadeMydataAadeMydataIndexRouteImport.update({
    id: '/(aade-mydata)/aade-mydata/',
    path: '/aade-mydata/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppstudentsStudentsSettingsRoute =
  AppstudentsStudentsSettingsRouteImport.update({
    id: '/(students)/students/settings',
    path: '/students/settings',
    getParentRoute: () => AppRouteRoute,
  } as any)
const ApprequestsRequestsSettingsRoute =
  ApprequestsRequestsSettingsRouteImport.update({
    id: '/(requests)/requests/settings',
    path: '/requests/settings',
    getParentRoute: () => AppRouteRoute,
  } as any)
const ApplessonsLessonsSettingsRoute =
  ApplessonsLessonsSettingsRouteImport.update({
    id: '/(lessons)/lessons/settings',
    path: '/lessons/settings',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppcontractsContractsSettingsRoute =
  AppcontractsContractsSettingsRouteImport.update({
    id: '/(contracts)/contracts/settings',
    path: '/contracts/settings',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppclassesClassesSettingsRoute =
  AppclassesClassesSettingsRouteImport.update({
    id: '/(classes)/classes/settings',
    path: '/classes/settings',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppaccountAccountSettingsRoute =
  AppaccountAccountSettingsRouteImport.update({
    id: '/(account)/account/settings',
    path: '/account/settings',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppaccountAccountGradesRoute = AppaccountAccountGradesRouteImport.update({
  id: '/(account)/account/grades',
  path: '/account/grades',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppaadeMydataAadeMydataSettingsRoute =
  AppaadeMydataAadeMydataSettingsRouteImport.update({
    id: '/(aade-mydata)/aade-mydata/settings',
    path: '/aade-mydata/settings',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppcustomEntitiesCustomEntitiesBuilderIndexRoute =
  AppcustomEntitiesCustomEntitiesBuilderIndexRouteImport.update({
    id: '/(custom-entities)/custom-entities/builder/',
    path: '/custom-entities/builder/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppcustomEntitiesCustomEntitiesSlugIndexRoute =
  AppcustomEntitiesCustomEntitiesSlugIndexRouteImport.update({
    id: '/(custom-entities)/custom-entities/$slug/',
    path: '/custom-entities/$slug/',
    getParentRoute: () => AppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/aade-mydata/settings': typeof AppaadeMydataAadeMydataSettingsRoute
  '/account/grades': typeof AppaccountAccountGradesRoute
  '/account/settings': typeof AppaccountAccountSettingsRoute
  '/classes/settings': typeof AppclassesClassesSettingsRoute
  '/contracts/settings': typeof AppcontractsContractsSettingsRoute
  '/lessons/settings': typeof ApplessonsLessonsSettingsRoute
  '/requests/settings': typeof ApprequestsRequestsSettingsRoute
  '/students/settings': typeof AppstudentsStudentsSettingsRoute
  '/aade-mydata/': typeof AppaadeMydataAadeMydataIndexRoute
  '/account/': typeof AppaccountAccountIndexRoute
  '/activity/': typeof AppactivityActivityIndexRoute
  '/analytics/': typeof AppanalyticsAnalyticsIndexRoute
  '/classes/': typeof AppclassesClassesIndexRoute
  '/contracts/': typeof AppcontractsContractsIndexRoute
  '/custom-entities/': typeof AppcustomEntitiesCustomEntitiesIndexRoute
  '/file-management/': typeof AppfileManagementFileManagementIndexRoute
  '/lessons/': typeof ApplessonsLessonsIndexRoute
  '/mobile-app/': typeof AppmobileAppMobileAppIndexRoute
  '/mydata/': typeof AppmydataMydataIndexRoute
  '/notes/': typeof AppnotesNotesIndexRoute
  '/notifications/': typeof AppnotificationsNotificationsIndexRoute
  '/profile/': typeof AppprofileProfileIndexRoute
  '/requests/': typeof ApprequestsRequestsIndexRoute
  '/rooms/': typeof ApproomsRoomsIndexRoute
  '/settings/': typeof AppsettingsSettingsIndexRoute
  '/students/': typeof AppstudentsStudentsIndexRoute
  '/subjects/': typeof AppsubjectsSubjectsIndexRoute
  '/teachers/': typeof AppteachersTeachersIndexRoute
  '/tenants/': typeof ApptenantsTenantsIndexRoute
  '/custom-entities/$slug/': typeof AppcustomEntitiesCustomEntitiesSlugIndexRoute
  '/custom-entities/builder/': typeof AppcustomEntitiesCustomEntitiesBuilderIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof AppIndexRoute
  '/aade-mydata/settings': typeof AppaadeMydataAadeMydataSettingsRoute
  '/account/grades': typeof AppaccountAccountGradesRoute
  '/account/settings': typeof AppaccountAccountSettingsRoute
  '/classes/settings': typeof AppclassesClassesSettingsRoute
  '/contracts/settings': typeof AppcontractsContractsSettingsRoute
  '/lessons/settings': typeof ApplessonsLessonsSettingsRoute
  '/requests/settings': typeof ApprequestsRequestsSettingsRoute
  '/students/settings': typeof AppstudentsStudentsSettingsRoute
  '/aade-mydata': typeof AppaadeMydataAadeMydataIndexRoute
  '/account': typeof AppaccountAccountIndexRoute
  '/activity': typeof AppactivityActivityIndexRoute
  '/analytics': typeof AppanalyticsAnalyticsIndexRoute
  '/classes': typeof AppclassesClassesIndexRoute
  '/contracts': typeof AppcontractsContractsIndexRoute
  '/custom-entities': typeof AppcustomEntitiesCustomEntitiesIndexRoute
  '/file-management': typeof AppfileManagementFileManagementIndexRoute
  '/lessons': typeof ApplessonsLessonsIndexRoute
  '/mobile-app': typeof AppmobileAppMobileAppIndexRoute
  '/mydata': typeof AppmydataMydataIndexRoute
  '/notes': typeof AppnotesNotesIndexRoute
  '/notifications': typeof AppnotificationsNotificationsIndexRoute
  '/profile': typeof AppprofileProfileIndexRoute
  '/requests': typeof ApprequestsRequestsIndexRoute
  '/rooms': typeof ApproomsRoomsIndexRoute
  '/settings': typeof AppsettingsSettingsIndexRoute
  '/students': typeof AppstudentsStudentsIndexRoute
  '/subjects': typeof AppsubjectsSubjectsIndexRoute
  '/teachers': typeof AppteachersTeachersIndexRoute
  '/tenants': typeof ApptenantsTenantsIndexRoute
  '/custom-entities/$slug': typeof AppcustomEntitiesCustomEntitiesSlugIndexRoute
  '/custom-entities/builder': typeof AppcustomEntitiesCustomEntitiesBuilderIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/': typeof AppIndexRoute
  '/_app/(aade-mydata)/aade-mydata/settings': typeof AppaadeMydataAadeMydataSettingsRoute
  '/_app/(account)/account/grades': typeof AppaccountAccountGradesRoute
  '/_app/(account)/account/settings': typeof AppaccountAccountSettingsRoute
  '/_app/(classes)/classes/settings': typeof AppclassesClassesSettingsRoute
  '/_app/(contracts)/contracts/settings': typeof AppcontractsContractsSettingsRoute
  '/_app/(lessons)/lessons/settings': typeof ApplessonsLessonsSettingsRoute
  '/_app/(requests)/requests/settings': typeof ApprequestsRequestsSettingsRoute
  '/_app/(students)/students/settings': typeof AppstudentsStudentsSettingsRoute
  '/_app/(aade-mydata)/aade-mydata/': typeof AppaadeMydataAadeMydataIndexRoute
  '/_app/(account)/account/': typeof AppaccountAccountIndexRoute
  '/_app/(activity)/activity/': typeof AppactivityActivityIndexRoute
  '/_app/(analytics)/analytics/': typeof AppanalyticsAnalyticsIndexRoute
  '/_app/(classes)/classes/': typeof AppclassesClassesIndexRoute
  '/_app/(contracts)/contracts/': typeof AppcontractsContractsIndexRoute
  '/_app/(custom-entities)/custom-entities/': typeof AppcustomEntitiesCustomEntitiesIndexRoute
  '/_app/(file-management)/file-management/': typeof AppfileManagementFileManagementIndexRoute
  '/_app/(lessons)/lessons/': typeof ApplessonsLessonsIndexRoute
  '/_app/(mobile-app)/mobile-app/': typeof AppmobileAppMobileAppIndexRoute
  '/_app/(mydata)/mydata/': typeof AppmydataMydataIndexRoute
  '/_app/(notes)/notes/': typeof AppnotesNotesIndexRoute
  '/_app/(notifications)/notifications/': typeof AppnotificationsNotificationsIndexRoute
  '/_app/(profile)/profile/': typeof AppprofileProfileIndexRoute
  '/_app/(requests)/requests/': typeof ApprequestsRequestsIndexRoute
  '/_app/(rooms)/rooms/': typeof ApproomsRoomsIndexRoute
  '/_app/(settings)/settings/': typeof AppsettingsSettingsIndexRoute
  '/_app/(students)/students/': typeof AppstudentsStudentsIndexRoute
  '/_app/(subjects)/subjects/': typeof AppsubjectsSubjectsIndexRoute
  '/_app/(teachers)/teachers/': typeof AppteachersTeachersIndexRoute
  '/_app/(tenants)/tenants/': typeof ApptenantsTenantsIndexRoute
  '/_app/(custom-entities)/custom-entities/$slug/': typeof AppcustomEntitiesCustomEntitiesSlugIndexRoute
  '/_app/(custom-entities)/custom-entities/builder/': typeof AppcustomEntitiesCustomEntitiesBuilderIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/aade-mydata/settings'
    | '/account/grades'
    | '/account/settings'
    | '/classes/settings'
    | '/contracts/settings'
    | '/lessons/settings'
    | '/requests/settings'
    | '/students/settings'
    | '/aade-mydata/'
    | '/account/'
    | '/activity/'
    | '/analytics/'
    | '/classes/'
    | '/contracts/'
    | '/custom-entities/'
    | '/file-management/'
    | '/lessons/'
    | '/mobile-app/'
    | '/mydata/'
    | '/notes/'
    | '/notifications/'
    | '/profile/'
    | '/requests/'
    | '/rooms/'
    | '/settings/'
    | '/students/'
    | '/subjects/'
    | '/teachers/'
    | '/tenants/'
    | '/custom-entities/$slug/'
    | '/custom-entities/builder/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/'
    | '/aade-mydata/settings'
    | '/account/grades'
    | '/account/settings'
    | '/classes/settings'
    | '/contracts/settings'
    | '/lessons/settings'
    | '/requests/settings'
    | '/students/settings'
    | '/aade-mydata'
    | '/account'
    | '/activity'
    | '/analytics'
    | '/classes'
    | '/contracts'
    | '/custom-entities'
    | '/file-management'
    | '/lessons'
    | '/mobile-app'
    | '/mydata'
    | '/notes'
    | '/notifications'
    | '/profile'
    | '/requests'
    | '/rooms'
    | '/settings'
    | '/students'
    | '/subjects'
    | '/teachers'
    | '/tenants'
    | '/custom-entities/$slug'
    | '/custom-entities/builder'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/'
    | '/_app/(aade-mydata)/aade-mydata/settings'
    | '/_app/(account)/account/grades'
    | '/_app/(account)/account/settings'
    | '/_app/(classes)/classes/settings'
    | '/_app/(contracts)/contracts/settings'
    | '/_app/(lessons)/lessons/settings'
    | '/_app/(requests)/requests/settings'
    | '/_app/(students)/students/settings'
    | '/_app/(aade-mydata)/aade-mydata/'
    | '/_app/(account)/account/'
    | '/_app/(activity)/activity/'
    | '/_app/(analytics)/analytics/'
    | '/_app/(classes)/classes/'
    | '/_app/(contracts)/contracts/'
    | '/_app/(custom-entities)/custom-entities/'
    | '/_app/(file-management)/file-management/'
    | '/_app/(lessons)/lessons/'
    | '/_app/(mobile-app)/mobile-app/'
    | '/_app/(mydata)/mydata/'
    | '/_app/(notes)/notes/'
    | '/_app/(notifications)/notifications/'
    | '/_app/(profile)/profile/'
    | '/_app/(requests)/requests/'
    | '/_app/(rooms)/rooms/'
    | '/_app/(settings)/settings/'
    | '/_app/(students)/students/'
    | '/_app/(subjects)/subjects/'
    | '/_app/(teachers)/teachers/'
    | '/_app/(tenants)/tenants/'
    | '/_app/(custom-entities)/custom-entities/$slug/'
    | '/_app/(custom-entities)/custom-entities/builder/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(tenants)/tenants/': {
      id: '/_app/(tenants)/tenants/'
      path: '/tenants'
      fullPath: '/tenants/'
      preLoaderRoute: typeof ApptenantsTenantsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(teachers)/teachers/': {
      id: '/_app/(teachers)/teachers/'
      path: '/teachers'
      fullPath: '/teachers/'
      preLoaderRoute: typeof AppteachersTeachersIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(subjects)/subjects/': {
      id: '/_app/(subjects)/subjects/'
      path: '/subjects'
      fullPath: '/subjects/'
      preLoaderRoute: typeof AppsubjectsSubjectsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(students)/students/': {
      id: '/_app/(students)/students/'
      path: '/students'
      fullPath: '/students/'
      preLoaderRoute: typeof AppstudentsStudentsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(settings)/settings/': {
      id: '/_app/(settings)/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppsettingsSettingsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(rooms)/rooms/': {
      id: '/_app/(rooms)/rooms/'
      path: '/rooms'
      fullPath: '/rooms/'
      preLoaderRoute: typeof ApproomsRoomsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(requests)/requests/': {
      id: '/_app/(requests)/requests/'
      path: '/requests'
      fullPath: '/requests/'
      preLoaderRoute: typeof ApprequestsRequestsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(profile)/profile/': {
      id: '/_app/(profile)/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AppprofileProfileIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(notifications)/notifications/': {
      id: '/_app/(notifications)/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof AppnotificationsNotificationsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(notes)/notes/': {
      id: '/_app/(notes)/notes/'
      path: '/notes'
      fullPath: '/notes/'
      preLoaderRoute: typeof AppnotesNotesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(mydata)/mydata/': {
      id: '/_app/(mydata)/mydata/'
      path: '/mydata'
      fullPath: '/mydata/'
      preLoaderRoute: typeof AppmydataMydataIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(mobile-app)/mobile-app/': {
      id: '/_app/(mobile-app)/mobile-app/'
      path: '/mobile-app'
      fullPath: '/mobile-app/'
      preLoaderRoute: typeof AppmobileAppMobileAppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(lessons)/lessons/': {
      id: '/_app/(lessons)/lessons/'
      path: '/lessons'
      fullPath: '/lessons/'
      preLoaderRoute: typeof ApplessonsLessonsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(file-management)/file-management/': {
      id: '/_app/(file-management)/file-management/'
      path: '/file-management'
      fullPath: '/file-management/'
      preLoaderRoute: typeof AppfileManagementFileManagementIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(custom-entities)/custom-entities/': {
      id: '/_app/(custom-entities)/custom-entities/'
      path: '/custom-entities'
      fullPath: '/custom-entities/'
      preLoaderRoute: typeof AppcustomEntitiesCustomEntitiesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(contracts)/contracts/': {
      id: '/_app/(contracts)/contracts/'
      path: '/contracts'
      fullPath: '/contracts/'
      preLoaderRoute: typeof AppcontractsContractsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(classes)/classes/': {
      id: '/_app/(classes)/classes/'
      path: '/classes'
      fullPath: '/classes/'
      preLoaderRoute: typeof AppclassesClassesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(analytics)/analytics/': {
      id: '/_app/(analytics)/analytics/'
      path: '/analytics'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AppanalyticsAnalyticsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(activity)/activity/': {
      id: '/_app/(activity)/activity/'
      path: '/activity'
      fullPath: '/activity/'
      preLoaderRoute: typeof AppactivityActivityIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(account)/account/': {
      id: '/_app/(account)/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof AppaccountAccountIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(aade-mydata)/aade-mydata/': {
      id: '/_app/(aade-mydata)/aade-mydata/'
      path: '/aade-mydata'
      fullPath: '/aade-mydata/'
      preLoaderRoute: typeof AppaadeMydataAadeMydataIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(students)/students/settings': {
      id: '/_app/(students)/students/settings'
      path: '/students/settings'
      fullPath: '/students/settings'
      preLoaderRoute: typeof AppstudentsStudentsSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(requests)/requests/settings': {
      id: '/_app/(requests)/requests/settings'
      path: '/requests/settings'
      fullPath: '/requests/settings'
      preLoaderRoute: typeof ApprequestsRequestsSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(lessons)/lessons/settings': {
      id: '/_app/(lessons)/lessons/settings'
      path: '/lessons/settings'
      fullPath: '/lessons/settings'
      preLoaderRoute: typeof ApplessonsLessonsSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(contracts)/contracts/settings': {
      id: '/_app/(contracts)/contracts/settings'
      path: '/contracts/settings'
      fullPath: '/contracts/settings'
      preLoaderRoute: typeof AppcontractsContractsSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(classes)/classes/settings': {
      id: '/_app/(classes)/classes/settings'
      path: '/classes/settings'
      fullPath: '/classes/settings'
      preLoaderRoute: typeof AppclassesClassesSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(account)/account/settings': {
      id: '/_app/(account)/account/settings'
      path: '/account/settings'
      fullPath: '/account/settings'
      preLoaderRoute: typeof AppaccountAccountSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(account)/account/grades': {
      id: '/_app/(account)/account/grades'
      path: '/account/grades'
      fullPath: '/account/grades'
      preLoaderRoute: typeof AppaccountAccountGradesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(aade-mydata)/aade-mydata/settings': {
      id: '/_app/(aade-mydata)/aade-mydata/settings'
      path: '/aade-mydata/settings'
      fullPath: '/aade-mydata/settings'
      preLoaderRoute: typeof AppaadeMydataAadeMydataSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(custom-entities)/custom-entities/builder/': {
      id: '/_app/(custom-entities)/custom-entities/builder/'
      path: '/custom-entities/builder'
      fullPath: '/custom-entities/builder/'
      preLoaderRoute: typeof AppcustomEntitiesCustomEntitiesBuilderIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(custom-entities)/custom-entities/$slug/': {
      id: '/_app/(custom-entities)/custom-entities/$slug/'
      path: '/custom-entities/$slug'
      fullPath: '/custom-entities/$slug/'
      preLoaderRoute: typeof AppcustomEntitiesCustomEntitiesSlugIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppaadeMydataAadeMydataSettingsRoute: typeof AppaadeMydataAadeMydataSettingsRoute
  AppaccountAccountGradesRoute: typeof AppaccountAccountGradesRoute
  AppaccountAccountSettingsRoute: typeof AppaccountAccountSettingsRoute
  AppclassesClassesSettingsRoute: typeof AppclassesClassesSettingsRoute
  AppcontractsContractsSettingsRoute: typeof AppcontractsContractsSettingsRoute
  ApplessonsLessonsSettingsRoute: typeof ApplessonsLessonsSettingsRoute
  ApprequestsRequestsSettingsRoute: typeof ApprequestsRequestsSettingsRoute
  AppstudentsStudentsSettingsRoute: typeof AppstudentsStudentsSettingsRoute
  AppaadeMydataAadeMydataIndexRoute: typeof AppaadeMydataAadeMydataIndexRoute
  AppaccountAccountIndexRoute: typeof AppaccountAccountIndexRoute
  AppactivityActivityIndexRoute: typeof AppactivityActivityIndexRoute
  AppanalyticsAnalyticsIndexRoute: typeof AppanalyticsAnalyticsIndexRoute
  AppclassesClassesIndexRoute: typeof AppclassesClassesIndexRoute
  AppcontractsContractsIndexRoute: typeof AppcontractsContractsIndexRoute
  AppcustomEntitiesCustomEntitiesIndexRoute: typeof AppcustomEntitiesCustomEntitiesIndexRoute
  AppfileManagementFileManagementIndexRoute: typeof AppfileManagementFileManagementIndexRoute
  ApplessonsLessonsIndexRoute: typeof ApplessonsLessonsIndexRoute
  AppmobileAppMobileAppIndexRoute: typeof AppmobileAppMobileAppIndexRoute
  AppmydataMydataIndexRoute: typeof AppmydataMydataIndexRoute
  AppnotesNotesIndexRoute: typeof AppnotesNotesIndexRoute
  AppnotificationsNotificationsIndexRoute: typeof AppnotificationsNotificationsIndexRoute
  AppprofileProfileIndexRoute: typeof AppprofileProfileIndexRoute
  ApprequestsRequestsIndexRoute: typeof ApprequestsRequestsIndexRoute
  ApproomsRoomsIndexRoute: typeof ApproomsRoomsIndexRoute
  AppsettingsSettingsIndexRoute: typeof AppsettingsSettingsIndexRoute
  AppstudentsStudentsIndexRoute: typeof AppstudentsStudentsIndexRoute
  AppsubjectsSubjectsIndexRoute: typeof AppsubjectsSubjectsIndexRoute
  AppteachersTeachersIndexRoute: typeof AppteachersTeachersIndexRoute
  ApptenantsTenantsIndexRoute: typeof ApptenantsTenantsIndexRoute
  AppcustomEntitiesCustomEntitiesSlugIndexRoute: typeof AppcustomEntitiesCustomEntitiesSlugIndexRoute
  AppcustomEntitiesCustomEntitiesBuilderIndexRoute: typeof AppcustomEntitiesCustomEntitiesBuilderIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppaadeMydataAadeMydataSettingsRoute: AppaadeMydataAadeMydataSettingsRoute,
  AppaccountAccountGradesRoute: AppaccountAccountGradesRoute,
  AppaccountAccountSettingsRoute: AppaccountAccountSettingsRoute,
  AppclassesClassesSettingsRoute: AppclassesClassesSettingsRoute,
  AppcontractsContractsSettingsRoute: AppcontractsContractsSettingsRoute,
  ApplessonsLessonsSettingsRoute: ApplessonsLessonsSettingsRoute,
  ApprequestsRequestsSettingsRoute: ApprequestsRequestsSettingsRoute,
  AppstudentsStudentsSettingsRoute: AppstudentsStudentsSettingsRoute,
  AppaadeMydataAadeMydataIndexRoute: AppaadeMydataAadeMydataIndexRoute,
  AppaccountAccountIndexRoute: AppaccountAccountIndexRoute,
  AppactivityActivityIndexRoute: AppactivityActivityIndexRoute,
  AppanalyticsAnalyticsIndexRoute: AppanalyticsAnalyticsIndexRoute,
  AppclassesClassesIndexRoute: AppclassesClassesIndexRoute,
  AppcontractsContractsIndexRoute: AppcontractsContractsIndexRoute,
  AppcustomEntitiesCustomEntitiesIndexRoute:
    AppcustomEntitiesCustomEntitiesIndexRoute,
  AppfileManagementFileManagementIndexRoute:
    AppfileManagementFileManagementIndexRoute,
  ApplessonsLessonsIndexRoute: ApplessonsLessonsIndexRoute,
  AppmobileAppMobileAppIndexRoute: AppmobileAppMobileAppIndexRoute,
  AppmydataMydataIndexRoute: AppmydataMydataIndexRoute,
  AppnotesNotesIndexRoute: AppnotesNotesIndexRoute,
  AppnotificationsNotificationsIndexRoute:
    AppnotificationsNotificationsIndexRoute,
  AppprofileProfileIndexRoute: AppprofileProfileIndexRoute,
  ApprequestsRequestsIndexRoute: ApprequestsRequestsIndexRoute,
  ApproomsRoomsIndexRoute: ApproomsRoomsIndexRoute,
  AppsettingsSettingsIndexRoute: AppsettingsSettingsIndexRoute,
  AppstudentsStudentsIndexRoute: AppstudentsStudentsIndexRoute,
  AppsubjectsSubjectsIndexRoute: AppsubjectsSubjectsIndexRoute,
  AppteachersTeachersIndexRoute: AppteachersTeachersIndexRoute,
  ApptenantsTenantsIndexRoute: ApptenantsTenantsIndexRoute,
  AppcustomEntitiesCustomEntitiesSlugIndexRoute:
    AppcustomEntitiesCustomEntitiesSlugIndexRoute,
  AppcustomEntitiesCustomEntitiesBuilderIndexRoute:
    AppcustomEntitiesCustomEntitiesBuilderIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
